import React from 'react'

export function ComboBox(props) {

    const handleChange = event => {
        if (props.callBack) {
            props.callBack(event)
        }
    }

    if (props && props.data && props.data.length > 0) {
        if (props.lot) {
            return (
                <div id={props.id}>
                    <ul>
                        {props.data.map(e => <li><input type="checkbox" id={e.id} value={e.id} /><label for={e.id}>{e.value}</label></li>)}
                    </ul>
                </div>
            )
        } else {
            return (
                <div id={props.id}>
                    <select name={props.id} className="form-control" isRequired={props.isRequired} onChange={handleChange}>
                        <option value="">Seleccione</option>
                        {props.data.map(e =>
                            <option value={e.id} selected={props.selectedValue == e.id ? 'selected' : ''}
                            >{e.value}</option>)}
                    </select>
                </div>
            )
        }
    } else {
        return (<div>No hay datos para mostrar</div>)
    }
}